// extracted by mini-css-extract-plugin
export var card = "_qx-0";
export var content = "_qx-2";
export var details = "_qx-3";
export var icon = "_qx-1";
export var iconBlue = "_qx-5";
export var iconBrand = "_qx-4";
export var iconGrayBlue = "_qx-6";
export var iconGreen = "_qx-7";
export var iconIndigo = "_qx-8";
export var iconOrange = "_qx-9";
export var iconPurple = "_qx-a";
export var iconRed = "_qx-b";
export var iconWarning = "_qx-c";